import { blobToUrl } from '@Utils/helpers/imageHelpers';
import _cloneDeep from 'lodash/cloneDeep';
import _groupBy from 'lodash/groupBy';
import _isNil from 'lodash/isNil';
import { IAnalysisEntity } from '@Data/qualityControl/Interfaces';
import { entityEndPoints, fileEndPoints } from '@Services/data/ApiHandler';
import store from '@Services/redux/Store';
import { IEntity } from './Interfaces';
import { EntityActions } from './Reducer';

const Api = {
    getDetailedData: async (
        entityId: string,
        callback: (response: any) => void
    ) => {
        const response = await entityEndPoints.getDetailedEntityData(entityId);
        if (response.isSuccess) {
            callback(response.data);
        }
    },
    setSelectedEntityVersion: (
        entityVersion: IEntity | IAnalysisEntity,
        callback?: () => void
    ) => {
        store.dispatch(EntityActions.setEntity(entityVersion));

        if (callback) {
            callback();
        }
    },
    getEntityVersionDetails: async (
        entityVersionUid: string,
        callback?: (selectedEntity: IEntity) => void
    ) => {
        const response = await entityEndPoints.getEntityVersionById(
            entityVersionUid
        );

        if (response.isSuccess) {
            const selectedEntity: IEntity = response.data;
            selectedEntity.thumbnails = [];
            selectedEntity.mainImages = [];
            store.dispatch(EntityActions.setEntity(selectedEntity));
            if (callback) {
                callback(selectedEntity);
            }

            Api._getEntityVersionImages(
                selectedEntity.images,
                entityVersionUid
            );

            return selectedEntity;
        }
    },
    _getEntityVersionImages: async (
        imageUrls: Array<string>,
        entityVersionUid: string
    ) => {
        const getImg = async (url) => {
            const thumbnailResp = await entityEndPoints.getEntityImage(
                url,
                true
            );
            const thmb = blobToUrl(thumbnailResp.data);
            store.dispatch(
                EntityActions.updateSelectedEntityThumbnails({
                    thumbnail: thmb,
                    entityVersionId: entityVersionUid,
                })
            );

            const mainImgResp = await entityEndPoints.getEntityImage(
                url,
                false
            );
            const main = blobToUrl(mainImgResp.data);
            store.dispatch(
                EntityActions.updateSelectedEntityMainImages({
                    main: main,
                    entityVersionId: entityVersionUid,
                })
            );
        };

        for (let i = 0; i < imageUrls.length; i++) {
            await getImg(imageUrls[i]);
        }
    },
    clearEntity: (callback?: () => void) => {
        store.dispatch(EntityActions.setEntity(null));
        if (callback) {
            callback();
        }
    },
    getEntityThumbnailUrl: async (
        thumbnailId: string,
        callback: (response: any) => void
    ) => {
        const response = await entityEndPoints.getEntityImage(
            thumbnailId,
            true
        );

        if (response.isSuccess) {
            callback(blobToUrl(response.data));
        }
    },
    getFullSizedImageUrl: async (
        imageId: string,
        callback?: (response: any) => void
    ) => {
        const response = await entityEndPoints.getEntityImage(imageId, false);
        if (response.isSuccess) {
            callback(blobToUrl(response.data));
        }
    },
    setIsEntityDrawerOpen: (isVisible: boolean) => {
        store.dispatch(EntityActions.setIsEntityDrawerOpen(isVisible));
    },
};

export default Api;
